exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asset-name.asset-name--empty{font-style:italic}.asset-name.asset-name--has-long-words{-ms-word-break:break-all;word-break:break-all;-webkit-hyphens:auto;-ms-hyphens:auto;hyphens:auto}.asset-name small{color:#565e76;margin-left:5px;font-size:smaller;font-style:italic}\n", ""]);

// exports
